import { currencies, defaultCurrency } from '@/constants/currency';
import { countriesOptions } from '@/constants/countries';

export const getCurrencySymbol = (currency: string): string => {
    const obj = currencies.find((item) => item.value.toLowerCase() === currency.toLowerCase());
    return obj?.symbol as string;
};

export const getCurrency = (country: string) => {
    if (country) {
        const countryInfo = countriesOptions.find((item) => item.value.toLowerCase() === country.toLowerCase());
        return countryInfo?.isoCode ? countryInfo?.isoCode : defaultCurrency;
    }
    return defaultCurrency;
};
